'use strict';

angular.module('AcaApp').factory('EmployerService',['EmployerResource',
function(EmployerResource){
  return {
    addEmployer: function(employer, flag){
      var rpcConfig;

      if(employer.foreigncorpind !== undefined){
        var employerCopy = Object.assign({}, employer);

        employerCopy.foreigncorpind = (employerCopy.foreigncorpind === true) ? '1' : '_';
        rpcConfig = {method: 'Save', params: [employerCopy, flag]};
      }
      else{
        rpcConfig = {method: 'Save', params: [employer, flag]};
      }

      return EmployerResource.executeRpc(rpcConfig).$promise;
    },
    getPayerList: function(){
      var rpcConfig = {method: 'getPayerList', params: []};

      return EmployerResource.executeRpc(rpcConfig).$promise;
    },
    GetEmployerRecords: function(){
      var rpcConfig = {method: 'GetEmployerRecords', params: []};

      return EmployerResource.executeRpc(rpcConfig).$promise;
    },
    GetEmployerByPk: function(ptin){
      var rpcConfig = {method: 'GetEmployerByPk', params: [ptin]};

      return EmployerResource.executeRpc(rpcConfig).$promise;
    },
    GetEmployerByPkToView: function(ptin){
      var rpcConfig = {method: 'GetEmployerByPk', params: [ptin]};
      var dataResult = new Promise(function(resolve, reject) {
        EmployerResource.executeRpc(rpcConfig).$promise.then(function(response) {
          var newData = Object.assign({}, response.result);

          newData.foreigncorpind = newData.foreigncorpind === '1' ? true : false;
          resolve({result: newData});
        }).catch(function(error) {
          reject(error);
        });
      });

      return dataResult;
    },
    UpdateEmployer: function(employer, flag){
      var employerCopy = Object.assign({}, employer);

      employerCopy.foreigncorpind = (employerCopy.foreigncorpind === true) ? '1' : '_';
      var rpcConfig = {method: 'UpdateEmployer', params: [employerCopy, flag]};

      return EmployerResource.executeRpc(rpcConfig).$promise;
    },
    DeleteEmployer: function(employer){
      var rpcConfig = {method: 'DeleteEmployer', params: [employer]};

      return EmployerResource.executeRpc(rpcConfig).$promise;
    },
    GetEmployers1095ReadyToTransmit: function(){
      var rpcConfig = {method: 'GetEmployers1095ReadyToTransmit', params: []};

      return EmployerResource.executeRpc(rpcConfig).$promise;
    },
    GetEmployerSponsors: function(){
      var rpcConfig = {method: 'GetEmployerSponsors', params: []};

      return EmployerResource.executeRpc(rpcConfig).$promise;
    },
    SearchEmployerRecords: function(search){
      var rpcConfig = {method: 'SearchEmployerRecords', params: [search]};
      return EmployerResource.executeRpc(rpcConfig).$promise;
    }
  };
}
]);
